import { render, staticRenderFns } from "./EditResponseComponent.vue?vue&type=template&id=32610717&"
import script from "./EditResponseComponent.vue?vue&type=script&lang=js&"
export * from "./EditResponseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports